export class DealerRequestFailure extends Error {
  constructor(msg: string, method = 'unknown method') {
    super(`Dealer request failed [${method}]: ${msg}`);

    Object.setPrototypeOf(this, DealerRequestFailure.prototype);
  }
}
